import React, { forwardRef } from 'react';
import styles from './styles.module.css';

const Label = forwardRef(({ title }, ref) => {
  return (
    <div ref={ref} className={styles.label}>{title}</div>
  );
});

Label.displayName = 'Label';
export default Label;
